module.exports = __webpack_public_path__ + "assets/auth-bottom-right.f12e36ae.svg";